module.exports = __webpack_public_path__ + "img/p14.649a026c.png";